// removed by extract-text-webpack-plugin
module.exports = {"text800":"_1p3ugqhY91bVMUN8EzmggX","text700":"K8cpqyE1VvIt6XMcyRJ8j","text600":"ded-esVJ-nhahiSrMViHg","text500":"_2BSx0OurmvJRQwndDoIsTN","text400":"_1c6zeaQTEa6PIkx_kfj8YA","text300":"_2A_7lT4jRpIwto1e7aEb48","text200":"_1InrNw11ZKXU_zK4l6YIOt","textParagraph":"dFZHqsIVtuG528gv6NKap","crimp":"_3DnorR7wEebiS7fMAK2qyb","trim":"_22mi09nfhZ6fm438uRAMuX","flexCenter":"f5PhF0FZh3KM5Adz3Ez0q","hideTextOverflow":"_2bysZUkK1MiVQi4QaODbuy","marginPageMainContent":"_3E8oMZKgi49yR_SmmeKZLa","actionButton":"_1U2MQkK5oSR9gXzUoO9ag1","button":"wRvV7CKNOrJorGK7v1hHe"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/forms/ButtonDelete.scss
// module id = 1169
// module chunks = 0